const embedPermissions = 'camera; microphone; autoplay; encrypted-media;'

export default embedPermissions
